import { CIcon } from '~/icons/types'

export const ciReadNotifications: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21.052 15.1a7.983 7.983 0 0 1-1.8-3.35 1 1 0 1 0-1.938.5 10.07 10.07 0 0 0 1.347 3.022 23.032 23.032 0 0 1-3.9.815h-.038a23.316 23.316 0 0 1-5.443 0h-.037a23.085 23.085 0 0 1-3.9-.816 9.98 9.98 0 0 0 1.654-5.52V9a5.006 5.006 0 0 1 5-5 4.942 4.942 0 0 1 3.062 1.048 1 1 0 0 0 1.227-1.581A7 7 0 0 0 4.996 9v.75a7.984 7.984 0 0 1-2.053 5.35 1 1 0 0 0 .4 1.607c1.508.557 3.067.967 4.654 1.225V18a4 4 0 0 0 8 0v-.07a24.9 24.9 0 0 0 4.659-1.22 1 1 0 0 0 .4-1.608l-.004-.002ZM11.997 20a2 2 0 0 1-1.993-1.827c1.327.105 2.66.105 3.986 0A2 2 0 0 1 11.997 20Z',
      fill: 'currentColor'
    },
    {
      d:
        'M10.662 7.7a1.002 1.002 0 1 0-1.33 1.5l4 3.557a1 1 0 0 0 .665.244c.033 0 .066 0 .1-.005a1 1 0 0 0 .7-.395l6-8a1 1 0 0 0-1.6-1.2l-5.347 7.13-3.188-2.83Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'read-notifications',
  type: 'regular',
  fill: 'none'
}
